import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { MetaService } from "src/app/Services/meta-data.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import { DomSanitizer } from "@angular/platform-browser";
@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss']
})
export class CookiePolicyComponent implements OnInit {

	staticContent: any;
	slug: string = "";
	lang: any;
	loading: boolean = false;
	environmentVariables: any;
	constructor(
			private pagesService: StaticPagesService,
			private route: ActivatedRoute,
			public embryoService: EmbryoService,
			public router: Router,
			private metaService: MetaService,
			private confgServ: StaticPagesService,
			private sanitizer: DomSanitizer
	) {
			this.lang = localStorage.getItem("lang");
			this.embryoService.emitLang.subscribe((lang: any) => {
					this.lang = localStorage.getItem("lang");
			});
			this.confgServ.getenvConfig().subscribe((res) => {
					this.environmentVariables = res;
			});
			router.events.subscribe((event) => {
					if (event instanceof NavigationEnd) {
							this.slug = this.route.snapshot.params["slug"];
							if (this.slug != "" && this.router.url.includes(this.slug)) {
									this.getStaticPages();
							}
					}
			});
	}

	ngOnInit(): void {
			this.route.params.subscribe((params) => {
					this.slug = params["slug"];
					this.getStaticPages();
			});
	}
	getStaticPages() {
			this.loading = true;
			this.pagesService.getStaticPage('cookie-policy','non-general').subscribe(
					(res) => {
							if (res.data) {
									this.staticContent = res.data;
									if (this.staticContent.iframe_url_ar) {
											this.staticContent.iframe_url_ar =
													this.sanitizer.bypassSecurityTrustResourceUrl(
															this.staticContent.iframe_url_ar
													);
									}
									if (this.staticContent.iframe_url_en) {
											this.staticContent.iframe_url_en =
													this.sanitizer.bypassSecurityTrustResourceUrl(
															this.staticContent.iframe_url_en
													);
									}
									if (this.staticContent.content_ar) {
											this.staticContent.content_ar =
													this.sanitizer.bypassSecurityTrustHtml(
															this.staticContent.content_ar
													);
									}
									if (this.staticContent.content_en) {
											this.staticContent.content_en =
													this.sanitizer.bypassSecurityTrustHtml(
															this.staticContent.content_en
													);
									}

									this.embryoService.emitLang.subscribe((lang: any) => {
											this.lang = lang;
											if (this.lang == "en")
													this.metaService.setTitle(
															`${this.staticContent?.title_en} - ${this.environmentVariables?.APP_NAME}`
													);
											else
													this.metaService.setTitle(
															`${this.staticContent?.title_ar} - ${this.environmentVariables?.APP_NAME_AR}`
													);
									});
							}
							else this.router.navigate([`/${this.lang}/not-found`]);
							this.loading = false;
					},
					(err) => {
							this.loading = false;
					}
			);
	}

}
